export const getRemindLaterInterval = (remindLaterVal) => {
  const formatedLocalDate = new Date(remindLaterVal);
  const presentDate = new Date();
  const diffHour = (formatedLocalDate.getTime() - presentDate.getTime()) / (1000 * 60 * 60);
  return Math.abs(Math.round(diffHour));
};
